import { Component, OnInit } from '@angular/core';
import { CartService } from '../shared-core/services/cart.service';
@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss'],
})
export class CartComponent implements OnInit {
  public hasItemsInCart = false;

  constructor(private service: CartService) {}

  ngOnInit(): void {
    this.service.loadShoppingCart();

    this.service.ModelSubject.subscribe(x => {
        this.hasItemsInCart = x.CartItems?.length > 0;
    });
  }
}
